import { createSlice } from "@reduxjs/toolkit";
import { initialState } from "./initial-state";
import { addZone } from "./thunks/add-zone";
import { listCoverage } from "./thunks/list-coverage";
import { updateZone } from "./thunks/update-zone";

const name = "coverage";

export const slice = createSlice({
  name,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(listCoverage.pending, (state) => {
        state.isPending = true;
        state.isRejected = false;
        state.errorMessage = "";
      })
      .addCase(listCoverage.fulfilled, (state, action) => {
        state.zones = action.payload;
        state.isPending = false;
        state.isRejected = false;
      })
      .addCase(listCoverage.rejected, (state, action) => {
        state.isPending = false;
        state.isRejected = true;
        state.errorMessage = action.error.message ?? "";
      })
      // Update + add share the saving/error flags; the screen re-reads coverage
      // on success so the tree + map reflect the change.
      .addCase(updateZone.pending, (state) => {
        state.isSaving = true;
        state.saveError = "";
      })
      .addCase(updateZone.fulfilled, (state) => {
        state.isSaving = false;
      })
      .addCase(updateZone.rejected, (state, action) => {
        state.isSaving = false;
        state.saveError = action.error.message ?? "";
      })
      .addCase(addZone.pending, (state) => {
        state.isSaving = true;
        state.saveError = "";
      })
      .addCase(addZone.fulfilled, (state) => {
        state.isSaving = false;
      })
      .addCase(addZone.rejected, (state, action) => {
        state.isSaving = false;
        state.saveError = action.error.message ?? "";
      });
  },
});

export const actions = slice.actions;
export const reducer = slice.reducer;
